export default function YesNoOptions(){
    const yes = "Yes";
    const no = "No";

    const yesNoOptions = [yes, no];

    return {yes, no, yesNoOptions};
}